import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import {FilterMyOrdersComponent} from "../../dialogs-otc/filter-my-orders/filter-my-orders.component";
import {OrderListItemModel} from "../../../models-otc/order-list-item-model";
import {BaseService} from "../../../../services/base.service";
import {HelperService} from "../../../../helper.service";
import dayjs from "dayjs";
import { Router } from "@angular/router";
import {NavBarComponent} from "../../../../nav-bar/nav-bar.component";
import {CreateNewOrderComponent} from "../../dialogs-otc/create-new-order/create-new-order.component";
import {SearchOrdersService} from "../../../services-otc/search-orders.service";
import {catchError, throwError} from "rxjs";
import {OrderManagerService} from "../../../services-otc/order-manager.service";
import {RepresentativeModel} from "../../../models-otc/representative-model";
import {FormBuilder, FormGroup} from "@angular/forms";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { Role } from 'src/app/models/role';
import { DownloadReportDialogComponent } from '../../dialogs-otc/download-report-dialog/download-report-dialog.component';
import { HttpResponse } from '@angular/common/http';
import { User } from 'src/app/models/user';
import { MaterialModel } from 'src/app/order-to-cash/models-otc/material-model';
import { PlantsModel } from 'src/app/order-to-cash/models-otc/plants-model';
import { ItemService } from 'src/app/order-to-cash/services-otc/item.service';
import { OrdinaryMaterialModel } from 'src/app/order-to-cash/models-otc/ordinary-material-model';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD.MM.YYYY"
    },
    display: {
      dateInput: "DD.MM.YYYY",
      monthYearLabel: "DD.MM.YYYY",
      dateA11yLabel: "DD.MM.YYYY",
      monthYearA11yLabel: "DD.MM.YYYY"
    }
  };

  export interface FilterValue {
    startDate: string,
    endDate: string,
    searchValue: string,
    statusIds: number[],
    clientIds: number[],
    forApproved?: boolean,
    forApprovals?: boolean,
    materialIds?: number[],
    plantIds?: number[]
}

@Component({
    selector: 'app-my-orders',
    templateUrl: './my-orders.component.html',
    styleUrls: ['./my-orders.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MyOrdersComponent  extends BaseService implements AfterViewInit, OnInit{

    tenantId = this.helper.getTenantId();
    userId = this.helper.getUserId();
    user: User = JSON.parse(sessionStorage.getItem('user'));

    @ViewChild(MatPaginator) paginatorMyOrders: MatPaginator

    representativeList : RepresentativeModel[];
    deafaultReprisentative: RepresentativeModel;
    selectedRepresentative: RepresentativeModel;
   
    orderId:number;
    currentPage: number = 0;
    pageSize: number =  20;
    totalElements: number = 0;

    isNoItemsFound: boolean = false;
    isRepresentative: boolean = false;
    isFilterBtnVisible: boolean = false;
    fullMaterialList: OrdinaryMaterialModel [] = [];
    plantList: PlantsModel[] = [];

    placeholder = '-';
    dateStingFormatting = 'DD.MM.YYYY';
    searchValue: string;
    filterResult: FilterValue = {
        startDate: '',
        endDate: '',
        searchValue: '',
        statusIds: [],
        clientIds: []
    };

    displayedColumns: string[] = ['orderNumber', 'ysapOrderNumber', 'orderDate', 'clientName', 'totalPrice', 'orderStatus', ' '];

    dataSource = new MatTableDataSource<OrderListItemModel>([]);

    constructor(
        private  searchOrdersService: SearchOrdersService,
        public dialog: MatDialog,
        public helper: HelperService,
        private router: Router,
        public nav: NavBarComponent,
        private orderManagerService: OrderManagerService,
        private itemService: ItemService
    ) {
        super();
    }

    ngOnInit(): void {

        if (sessionStorage.getItem("orderApprovalRedirectLink") != null) {
            let orderApprovalRedirectUrl: String = sessionStorage.getItem('orderApprovalRedirectLink');
            sessionStorage.removeItem("orderApprovalRedirectLink");
            this.router.navigate([orderApprovalRedirectUrl]);
        }
        
        if(sessionStorage.getItem('myOrdersFilter') !== null) {
            this.filterResult = JSON.parse(sessionStorage.getItem('myOrdersFilter'));
            this.searchValue = this.filterResult?.searchValue;
            this.hideShowFilterReset();
        }

        let roleCheck = sessionStorage.getItem('roles');

        if (roleCheck.includes('OTCRepresentative')) {
            this.isRepresentative = true;
            this.populateRepresentativeList();
        } else{
            this.populateOrderList();
            this.isRepresentative = false;
        }
        this.populateFullMaterialList();
        this.populatePlantList();
    }

    populateFullMaterialList() {
        this.itemService.getFullMaterialList().subscribe({
            next: (response) => {
                if(response) {
                    this.fullMaterialList = response;
                }
            }
        });
    }

    populatePlantList() {
        this.itemService.getPlantsList().subscribe({
            next: (response) => {
                if(response) {
                    this.plantList = response;
                }
            }
        })
    }

    checkRepresentative() {
        let sessionRep = JSON.parse(sessionStorage.getItem('representative'));

        if(this.representativeList?.length > 0) {
            for(let representative of this.representativeList) {
                if(sessionRep?.agentUserId === representative?.agent?.id || sessionRep?.agent?.id === representative?.agent?.id){
                    this.setSelectedRepresentative(representative);
                    break;
                }
            }

            if(!this.selectedRepresentative) {
                this.setSelectedRepresentative(this.representativeList[0]);
            }
        }
    }

    searchOrders(){        
        setTimeout(()=>{
            this.filterResult.searchValue = this.searchValue;
            sessionStorage.setItem('myOrdersFilter', JSON.stringify(this.filterResult));
            this.populateOrderList();
        },1400)
        this.hideShowFilterReset();
    }

    onPaginateChange(event: PageEvent) {
        this.currentPage = event.pageIndex;
        this.pageSize = event.pageSize;
        this.totalElements = event.length;
        this.populateOrderList();
    }
    populateOrderList(){
        this.nav.toggleLoading(true);
        this.searchOrdersService.getOrderList(
            this.currentPage,
            this.pageSize,
            this.searchValue?.trim()?.toLocaleLowerCase(),
            this.filterResult?.clientIds,
            this.filterResult?.startDate,
            this.filterResult?.endDate,
            this.filterResult?.statusIds,
            this.filterResult?.plantIds,
            this.filterResult?.materialIds
        )
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.dataSource.data = response.content;
                        if(response.content.length === 0){
                            this.isNoItemsFound = true;
                        }else{
                            this.isNoItemsFound = false;
                        }

                        this.totalElements = response.totalElements;
                    } else {
                        this.isNoItemsFound = true;
                    }

                    this.nav.toggleLoading(false);
                },
                error: () => {
                    this.nav.toggleLoading(false);
                    this.isNoItemsFound = true;
                }
            });
    }

    openDownloadReportDialog() {
        const dialogRef = this.dialog.open(DownloadReportDialogComponent, {
            data: {
                plantList: this.plantList
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if(result) {
                this.nav.toggleLoading(true);

                if(result?.to === null && result?.from === null) {
                    result.from = "2010-01-01";
                    result.to = dayjs().format('YYYY-MM-DD');
                }
                
                this.orderManagerService.downloadOrderReport(result, this.user.id).subscribe({
                    next: (response: HttpResponse<Blob>) => {
                        console.log(response)
                        if(response) {
                            const blob = response.body;
                            const filename = response.headers.get('Content-Disposition')?.split('filename=')[1] || 'report.xlsx';
                            
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = 'AllFarm_Order_Report.xlsx';
                            a.click();
                            window.URL.revokeObjectURL(url);
                        }
                        this.nav.toggleLoading(false);
                    },
                    error: (error) => {
                        console.error(error);
                        this.nav.toggleLoading(false);
                    }
                });
            }
        });
    }


    populateRepresentativeList() {
        this.orderManagerService.getRepresentativeList(this.userId)
            .pipe(
                catchError((error) => {
                    console.error(error);
                    return throwError(() => error);
                })
            )
            .subscribe((response) => {
                this.representativeList = response;
                this.checkRepresentative();
            });

    }

    //// SET DETAILS ////
    setSelectedRepresentative(representative: RepresentativeModel) {
        let representativeJSON = JSON.stringify(representative);
        sessionStorage.setItem("representative", representativeJSON);
        this.selectedRepresentative = representative;
        this.populateOrderList();
    }


    hideShowFilterReset(){
        this.isFilterBtnVisible = this.filterResult?.materialIds?.length > 0 || this.filterResult?.plantIds?.length > 0 || this.filterResult?.startDate?.length > 0 || this.filterResult?.endDate?.length > 0 || this.filterResult?.clientIds?.length > 0 || this.filterResult?.statusIds?.length > 0 || this.searchValue?.length > 0;
    }


    resetFilter(){
        this.refreshBrowser();
    }

    openFilterDialog(){
        const dialogRef = this.dialog.open(FilterMyOrdersComponent, {
            data: {
                filterResult: this.filterResult,
                materialList: this.fullMaterialList,
                plantList: this.plantList
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.filterResult.startDate = result.startDate;
                this.filterResult.endDate = result.endDate;
                this.filterResult.clientIds = result.clientIds;
                this.filterResult.statusIds = result.statusIds;
                this.filterResult.materialIds = result.materialIds;
                this.filterResult.plantIds = result.plantIds;

                sessionStorage.setItem('myOrdersFilter', JSON.stringify(this.filterResult));
            }
            this.populateOrderList();
            this.hideShowFilterReset();
        });
    }

    openCreateNewOrderDialog(){
        const dialogRef = this.dialog.open(CreateNewOrderComponent, {});

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    reviewOrder(id:number){
        this.router.navigate([`/order-manager/order/${id}`]);
    }

    refreshBrowser() {
        sessionStorage.removeItem('myOrdersFilter');
        // FORCE REFRESH BROWSER
        this.router.navigateByUrl("/order-manager/approvals", { skipLocationChange: true }).then(() => {
            this.router.navigate(["/order-manager/my-orders"]);
        });
    }

    ngAfterViewInit() {

    }

    protected readonly dayjs = dayjs;
    protected readonly sessionStorage = sessionStorage;
}
